var exports = {
  "tag": "x24da60e8--dddba4--tag",
  "desktop": "x24da60e8--dddba4--desktop",
  "phone": "x24da60e8--dddba4--phone",
  "tablet": "x24da60e8--dddba4--tablet",
  "with-border": "x24da60e8--dddba4--with-border",
};

module.exports = exports;
